import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const tomi = [{
  num: '01',
  icon: '📘',
  tag: 'TOMO 1',
  title: 'Fondamenti della Domotica',
  desc: 'Dai protocolli di comunicazione (KNX, BACnet, DALI) alle architetture di sistema. Il punto di partenza per capire come funziona davvero un edificio intelligente. Include storia, ecosistemi, normativa e mercato europeo 2025.'
}, {
  num: '02',
  icon: '📗',
  tag: 'TOMO 2',
  title: 'Sensori e Dispositivi Intelligenti',
  desc: 'Classificazione completa dei sensori (temperatura, CO₂, presenza mmWave), attuatori, sistemi di illuminazione HCL e controllo HVAC. Con lettura datasheet e selezione professionale per ogni applicazione reale.'
}, {
  num: '03',
  icon: '📙',
  tag: 'TOMO 3',
  title: 'Smart Home e Internet of Things',
  desc: 'Architettura IoT a 4 livelli, Matter 1.3, Thread, Zigbee, Home Assistant, Node-RED e automazioni avanzate. Include cybersecurity IoT e configurazione VLAN per impianti sicuri.'
}, {
  num: '04',
  icon: '📕',
  tag: 'TOMO 4',
  title: 'Impianti Domotici e Installazioni',
  desc: 'Il tomo più tecnico e pratico. Progettazione KNX completa, schemi unifilari e funzionali, dimensionamento quadri elettrici, cablaggio, configurazione ETS 6 e collaudo professionale secondo CEI 64-8.'
}, {
  num: '05',
  icon: '📒',
  tag: 'TOMO 5',
  title: 'Sicurezza, Controllo e Automazione',
  desc: 'TVCC IP con calcolo DORI, sistemi antintrusione EN 50131 Grado 2, controllo accessi RFID, integrazione con domotica e GDPR per la videosorveglianza. Include audit di sicurezza informatica.'
}, {
  num: '06',
  icon: '📓',
  tag: 'TOMO 6',
  title: 'Progetti, Simulazioni e Casi Reali',
  desc: 'Quattro progetti completi (villa residenziale, smart office, hotel boutique, condominio NZEB), troubleshooting avanzato, casi reali europei e verifica finale integrativa da 100 punti.'
}];
export function TomiSection() {
  return <section className="py-10 sm:py-12 px-4 bg-[#0d0d17] relative border-t border-brand-orange/10" data-id="element-324">
      <div className="max-w-5xl mx-auto" data-id="element-325">
        <div className="text-center mb-8" data-id="element-326">
          <p className="text-xs font-black tracking-widest text-brand-orange uppercase mb-3" data-id="element-327">
            Archivio tecnico
          </p>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl md:text-5xl font-black text-brand-cream mb-3" data-id="element-328">
            I <span className="text-brand-orange" data-id="element-329">6 Tomi</span> del Sistema —{' '}
            <span className="text-brand-gold" data-id="element-330">In Dettaglio</span>
          </motion.h2>
          <p className="text-gray-400 text-sm sm:text-base" data-id="element-331">
            Sei volumi tecnici che coprono l'intera filiera della domotica
            professionale.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4" data-id="element-332">
          {tomi.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-brand-card border border-white/10 p-6 rounded-2xl relative overflow-hidden group hover:border-brand-orange/40 transition-colors" data-id="element-333">
              <div className="absolute -right-4 -top-4 text-7xl font-black text-white/5 group-hover:text-brand-orange/10 transition-colors" data-id="element-334">
                {tomo.num}
              </div>
              <div className="relative z-10" data-id="element-335">
                <div className="inline-flex items-center gap-2 bg-brand-orange text-white text-[10px] font-black px-3 py-1 rounded-full mb-3 uppercase tracking-wider" data-id="element-336">
                  <span data-id="element-337">{tomo.icon}</span>
                  {tomo.tag}
                </div>
                <h3 className="text-xl font-bold text-brand-cream mb-3 leading-tight" data-id="element-338">
                  {tomo.title}
                </h3>
                <p className="text-gray-400 text-sm font-medium leading-relaxed" data-id="element-339">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-8" data-id="element-340">
          <CTAButton className="max-w-md mx-auto" data-id="element-341">
            VOGLIO I 6 TOMI — ACCEDI SUBITO
          </CTAButton>
        </div>
      </div>
    </section>;
}